import Modal from "react-bootstrap/Modal";
import { ReactSVG } from "react-svg";
import { NavDropdown, Table } from "react-bootstrap";
import srxlogowithtext from "../../../../../assets/images/SRX-logo-with-text.svg";
import exporticon from "../../../../../assets/images/export-icon.svg";
import excelicon from "../../../../../assets/images/excel-icon.svg";
import arrowdown from "../../../../../assets/images/angle-down.svg";
import useInventory from "../../../../../Hooks/useInventory";
import { useEffect, useState } from "react";
import moment from "moment";
import Loading from "../../../../../components/LoadingPage/Loading";
import { currencyFormatter } from "../../../../../utils/commonUtils";
export const InventoryTransactionReportsModel = ({
  showReportModal,
  onCloseReportModal,
  selectedItem,
}: any) => {
  const [TrReportData, setTrReportData] = useState<any>([]);
  const { inventoryTransactionsAPI,
    inventoryTransactionsLoading,
    exportInventoryTransactionsAPI,
    invTransactionsExportLoading,
  } = useInventory();
  useEffect(() => {
    inventoryTransactionsAPI(selectedItem.rxSRXId).then((res) => {
      setTrReportData(res[0]);
    });
  }, [showReportModal]);
  const getTotal = () => {
    let sum = 0;
    TrReportData?.reportData?.forEach((x: any) => {
      sum = sum + parseFloat(x.transQty);
    });
    return parseFloat(sum.toString());
  };
  const exportReport = async () => {
    const response = await exportInventoryTransactionsAPI({
      rxSRXId: selectedItem.rxSRXId
    });
    const url = URL.createObjectURL(response);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${localStorage.getItem("profileClientId")?.toUpperCase() ?? ""}_Inventory_Transaction_Report_${moment().format('YYYYMMDD_HHmmss')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  }

  return (
    <Modal
      size="xl"
      id="trans-report-modal"
      show={showReportModal}
      onHide={onCloseReportModal}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h4>View Report</h4>
          <div className="trans-report-action-wrapper">
            {/* <div className="trans-report-action-box download-report-box">
              <ReactSVG className="svg-box" wrapper="span" src={downloadicon} />
            </div> */}
            <div className="trans-report-action-box export-report-opt-box">
              <ReactSVG className="svg-box" wrapper="span" src={exporticon} />
              <NavDropdown title="Export Report">
                <NavDropdown.Item onClick={() => exportReport()}>
                  <img src={excelicon} alt="" /> Excel
                </NavDropdown.Item>
              </NavDropdown>
              <ReactSVG className="svg-box" wrapper="span" src={arrowdown} />
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {inventoryTransactionsLoading || invTransactionsExportLoading ? <Loading /> : null}
        <div className="trans-report-content-wrapper">
          <div className="trans-report-content-header">
            <div className="header-content">
              <h5>Transaction Report</h5>
              <p>{TrReportData?.subTitleReport}</p>
            </div>
            <div className="header-logo-wrapper">
              <div className="header-logo-box srx-logo-box">
                <img src={srxlogowithtext} alt="srx" />
              </div>
              <div className="header-logo-box sf-logo-box">
                <img src={TrReportData?.clientImage + `?ts=${Date.now()}`} alt="img" />
              </div>
            </div>
          </div>
          <div className="trans-report-detail-box-wrapper">
            <h5>{TrReportData?.rxName}</h5>

            <div className="trans-report-detail-box-container" style={{ overflow: "auto" }}>
              <div className="trans-report-detail-box">
                <label>SRX Barcode</label>
                <p>{TrReportData?.rxSRXId || "-"}</p>
              </div>
              <div className="trans-report-detail-box">
                <label>Manufacturer</label>
                <p>{TrReportData?.manufacturer || "-"}</p>
              </div>
              <div className="trans-report-detail-box">
                <label>NDC</label>
                <p>{TrReportData?.ndcCode || "-"}</p>
              </div>
              <div className="trans-report-detail-box">
                <label>LOT No.</label>
                <p>{TrReportData?.lotNo || "-"}</p>
              </div>
              <div className="trans-report-detail-box">
                <label>Exp.Date</label>
                <p>{TrReportData?.expiryDate ? moment(TrReportData?.expiryDate).format("MM/DD/YYYY") : "-"}</p>
              </div>
            </div>

            <div className="trans-report-table-wrapper" style={{ overflow: "auto" }}>
              <Table bordered={false} hover={true}>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Trans.Type</th>
                    <th>Ref. No</th>
                    <th>user</th>
                    <th>location</th>
                    <th>Qty.</th>
                    <th>Current qty.</th>
                    <th>price</th>
                    <th>trans.value</th>
                    <th>current value</th>
                  </tr>
                </thead>
                <tbody>
                  {TrReportData?.reportData?.length ? (
                    TrReportData?.reportData?.map((report: any) => (
                      <tr>
                        <td>{report.createdOnUtc ? report.createdOnUtc : "NA"}</td>
                        <td>{report.transactionName}</td>
                        <td>{report.referenceNumber}</td>
                        <td>{report.userName}</td>
                        <td>{report.locationName}</td>
                        <td style={{ textAlign: "right" }}>{parseFloat(report.transQty)}</td>
                        <td style={{ textAlign: "right" }}>{parseFloat(report.currentQty)}</td>
                        <td style={{ textAlign: "right" }}>{currencyFormatter(report.price)}</td>
                        <td style={{ textAlign: "right" }}>{currencyFormatter(report.transactionValue)}</td>
                        <td style={{ textAlign: "right" }}>{currencyFormatter(report.currentValue)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center" }}>No transaction data found</td>
                    </tr>
                  )}
                  <tr>
                    <th colSpan={5}>Total</th>
                    <th colSpan={5} style={{ fontSize: "14px" }}>{getTotal()}</th>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
